import { styled } from "@mui/material";
// @ts-ignore
export const Page = styled("div")({
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
});
//# sourceMappingURL=Page.js.map